var objectWithoutPropertiesLoose = {exports: {}};

export { objectWithoutPropertiesLoose as __module };
